module.exports = "https://coursera_assets.s3.amazonaws.com/images/8658fdfbe8fce937b9ab1bbb22c6bf80.png";